export const IS_GC_PAYMENT_METHOD = 'IS_GC_PAYMENT_METHOD';

export enum PaymentMethodTypes {
  CREDIT_OR_DEBIT = 'scheme',
  PAYPAL = 'paypal',
  GOOGLE_PAY = 'googlepay',
  APPLE_PAY = 'applepay',
  GIFT_CARD = 'giftcard',
  GROUP_KLARNA = 'groupklarna',
  KLARNA = 'klarna',
  KLARNA_ACCOUNT = 'klarna_account',
  KLARNA_PAYNOW = 'klarna_paynow',
  IDEAL = 'ideal',
  MBWAY = 'mbway',
  MOBILE_PAY = 'mobilepay',
  ONLINE_BANKING_PL = 'onlineBanking_PL',
  TWINT = 'twint',
  MULTIBANCO = 'multibanco',
  BANCONTACT_MOBILE = 'bcmc_mobile',
}

export const UNKNOWN_PAYMENT_METHOD = 'unknown payment method';
